<template>
  <div>
    <vx-card title="Обновить Лицевой счет" class="p-6">
      <div class="mb-5">
        <h5 class="mb-4">Житель:</h5>
        <div v-if="selectedUser">
          <p class="mb-2">
            ФИО:
            <span class="text-primary">{{ selectedUser.user.full_name }}</span>
          </p>
          <p
            v-for="(home, index) in selectedUser.user.homes"
            :key="index"
            class="mb-2"
          >
            Поселок:
            <span class="text-primary">{{ home.county_type.name }}</span
            >, участок
            <span class="text-primary">#{{ home.homestead_number }}</span>
          </p>
        </div>

        <vs-button
          @click="selectUser"
          class="mr-5 vs-con-loading__container"
          type="relief"
          vslor="primary"
        >
          Изменить жителя
        </vs-button>
      </div>
      <div v-if="selectedUser" class="mb-5">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          label="ЛС"
          name="ЛС"
          v-model="selectedUser.account"
        />
        <span class="text-danger text-sm">{{ errors.first("ЛС") }}</span>
      </div>
      <div v-if="selectedUser" class="mb-5">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          label="Баланс"
          name="Баланс"
          type="number"
          v-model.number="selectedUser.saldo"
        />
        <span class="text-danger text-sm">{{ errors.first("Баланс") }}</span>
      </div>

      <vs-button
        @click="updateAccount"
        :disabled="!validateForm"
        class="mr-5"
        color="primary"
      >
        Обновить
      </vs-button>
      <vs-button
        @click="deleteAccount"
        class="mr-5"
        type="relief"
        color="danger"
      >
        Удалить
      </vs-button>
    </vx-card>

    <vs-popup
      v-if="selectedUser"
      title="Выбрать жителя"
      :active.sync="activeSelectUserPrompt"
    >
      <div class="flex flex-wrap items-center justify-between w-full">
        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterUsers"
            label="name"
            :options="userRole"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.user_role"
            placeholder="Роль пользователя"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterUsers"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.homes__county_type"
            placeholder="Выбор поселения"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="ФИО"
            v-model="filter.full_name__icontains"
          />
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Телефон"
            v-model="filter.phone"
          />
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filter.homes__homestead_number"
          />
        </div>
      </div>
      <div>
        <vs-table
          v-model="selectedUser.user"
          :data="users"
          :stripe="false"
          :search="false"
          :pagination="false"
          :maxItems="20"
          noDataText="Элементов не найдено"
          id="div-with-loading"
        >
          <template slot="thead">
            <vs-th> # </vs-th>
            <vs-th> ФИО </vs-th>
            <vs-th> Адрес </vs-th>
            <vs-th> Статус </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].id">
                {{ data[indextr].id }}
              </vs-td>

              <vs-td :data="data[indextr].full_name">
                {{ data[indextr].full_name }}
              </vs-td>

              <vs-td>
                <template v-if="data[indextr].in_consideration">
                  <p class="mb-2">
                    Поселок:
                    <span class="text-primary">{{
                      data[indextr].county_type.name
                    }}</span>
                    <br />
                    Номер участка:
                    <span class="text-primary">{{
                      data[indextr].addresses[0]
                    }}</span>
                  </p>
                </template>
                <template v-else>
                  <p
                    v-for="(address, index) in data[indextr].homes"
                    :key="index"
                    class="mb-2"
                  >
                    {{ index + 1 }}.
                    <span class="text-primary">{{
                      address.county_type.name
                    }}</span
                    >, участок #
                    <span class="text-primary">{{
                      address.homestead_number
                    }}</span
                    >, ул.
                    <span class="text-primary">{{ address.address }}</span>
                  </p>
                </template>
              </vs-td>

              <vs-td>
                <template
                  v-if="
                    data[indextr].is_confirmed &&
                    !data[indextr].in_consideration
                  "
                >
                  <span class="text-success">Одобрен</span>
                </template>
                <template
                  v-else-if="
                    !data[indextr].is_confirmed &&
                    !data[indextr].in_consideration
                  "
                >
                  <span class="text-danger">Отклонен</span>
                </template>
                <template
                  v-else-if="
                    !data[indextr].is_confirmed &&
                    data[indextr].in_consideration
                  "
                >
                  <span class="text-primary">На модерации</span>
                </template>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          class="mt-4"
          :total="totalPagePagination"
          v-model="currentPagingationPage"
        ></vs-pagination>
        <vs-button
          @click="confirmSelect"
          :disabled="!selectUserValidate"
          color="primary"
          type="filled"
          >Выбрать</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { API_URL, countyType, userRole, userStatus } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    countyType,
    userStatus,
    userRole,

    users: [],
    filter: {
      is_confirmed: true,
    },
    countElements: 10,
    selectedUser: null,

    currentPagingationPage: 1,
    totalUsers: 0,
    totalPagePagination: 1,

    activeSelectUserPrompt: false,
  }),
  components: {},
  watch: {
    "$route.params.id": {
      handler: function (id) {
        this.getTicket(id);
      },
    },
    filter: {
      handler(val) {
        this.filterUsers();
      },
      deep: true,
    },
    currentPagingationPage: function () {
      this.getUsers();
    },
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.selectedUser !== null &&
        this.selectedUser.user !== null &&
        this.selectedUser.account !== ""
      );
    },
    selectUserValidate() {
      return !this.errors.any() && this.selectedUser !== null;
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    filterUsers: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getUsers();
    }, 500),
    updateAccount() {
      this.$load(async () => {
        let payload = {
          user: this.selectedUser.user.id,
          account: this.selectedUser.account,
          saldo: this.selectedUser.saldo,
        };

        try {
          let res = await this.$api.personalAccounts.updateAccount(
            this.$route.params.id,
            payload
          );

          this.notification("Успешно", "Лицевой счет обновлен", "success");
        } catch (error) {
          this.notification(
            "Ошибка",
            "Не удалось обновить Лицевой счет",
            "danger"
          );
        }
      });
    },
    selectUser() {
      this.getUsers();
      this.activeSelectUserPrompt = true;
    },
    getUsers() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements;

      this.$load(async () => {
        let res = (await this.$api.users.getAllUsers(this.filter)).data;

        this.totalUsers = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalUsers / this.countElements
        );

        res.results.forEach((user) => {
          user.county_type = countyType.find((x) => x.id == user.county_type);

          if (user.homes.length > 0) {
            user.homes.forEach((home) => {
              home.county_type = countyType.find(
                (x) => x.id == home.county_type
              );
            });
          }
        });

        this.users = res.results;
        this.$vs.loading.close();
      });
    },
    confirmSelect() {
      this.activeSelectUserPrompt = false;
    },
    getAccount() {
      this.$load(async () => {
        let res = (
          await this.$api.personalAccounts.getAccount(this.$route.params.id)
        ).data;

        let homes = res.user.homes;
        homes.forEach((home) => {
          home.county_type = countyType.find((x) => x.id == home.county_type);
        });

        this.selectedUser = res;
      });
    },
    deleteAccount() {
      this.$load(async () => {
        try {
          let res = await this.$api.personalAccounts.deleteAccount(
            this.$route.params.id
          );

          this.notification("Успешно", "Лицевой счет удален", "success");
          this.$router.push({ name: "communal-payments-personal-accounts" });
        } catch (error) {
          this.notification(
            "Ошибка",
            "Не удалось удалить Лицевой счет",
            "danger"
          );
        }
      });
    },
  },
  mounted() {
    this.getAccount();
  },
};
</script>